import React, { useRef, useState, useEffect } from "react"

const MapsCEPAL = (props) => {
    const { options, path, style, debugMsg, children } = props;

    const options_b64 = btoa( JSON.stringify(options) );
    const path_b64 = btoa( path );

    return (
        <iframe
            title="Maps content"
            width="800"
            height="600"
            style={style}
            src={`${path}/index.html?path=${path_b64}&options=${options_b64}`}
        >
        </iframe>
    );
};

export default MapsCEPAL;

/*
USE:
let myMap = new window.mapasCEPAL( params );

params is an object with the following structure:

{
    options: {
        geoJSON: (string) url geojson with polygons,
        centroids: (string) url geojson with centroids,
        codeFeature: (string) name of feature code in geoJSON file
        codeFeatureNum: (string) name of numerical feature code in geoJSON file
    },
    module: [ // array with loaded modules
        {
            module: 'mobility',
            active: true, // optional
            options: {
                dataJSON: './data/mb-trab-dame-gtm2018.json',
            }
        },
        {
            module: 'redatam-generic',
            active: true, // optional
            options: {
                arealist: './data/PRUEBA_VAR_INDIC_DEPTO-PER2017_ab20.json',
            }
        },
        {
            module: 'migration',
            active: true, // optional
            options: {
                dataJSON: './data/mb-trab-dame-gtm2018.json',
            }
        },
        {
            module: 'segregation',
            active: true, // optional
            options: {
                segregationJSON: './data/DATOS_SEGREG.JSON',
            }
        },
        {
            module: 'tablelist',
            active: true, // optional
            options: {
                tablelistJSON: './data/mc-indics-dame-gtm2018.json',
            }
        },
    ]
}
*/
